import classicDocument from './documentServicesDataFixer'
import responsiveDocument from './responsiveDocumentDataFixers'

export default {
    classicDocument,
    responsiveDocument
}
